import React from "react";
import styled, { keyframes } from "styled-components";
import { style } from "../style";

type Props = {
  display?: "block" | "inline-block" | "inline" | "none";
  faded?: boolean;
};

type ContainerProps = {
  $display: "block" | "inline-block" | "inline" | "none";
  $faded: boolean;
};

type ChildWrapperProps = {
  $display: "block" | "inline-block" | "inline" | "none";
};

const Container = styled.div<ContainerProps>`
  position: relative;
  display: ${(props) => props.$display};
  opacity: ${(props) => (props.$faded ? 0.3 : 1)};
`;

const ChildWrapper = styled.div<ChildWrapperProps>`
  display: ${(props) => props.$display};
  opacity: 0;
`;

const moveMask = keyframes`
  100% {
    mask-position:left;
  }
`;

const Mask = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  border-radius: 10px;

  background: ${style.colors.grey.primary};
  mask: linear-gradient(-60deg, #000 30%, #0005, #000 70%) right/300% 100%;

  animation: ${moveMask} 1s ease-in-out infinite;
`;

export const SkeletonMask: React.FC<Props> = (props) => {
  const { display = "block", faded = false, children = <span children={<br />} /> } = props;

  return (
    <Container $display={display} $faded={faded}>
      <ChildWrapper $display={display}>{children}</ChildWrapper>
      <Mask />
    </Container>
  );
};
